/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { ReactElement, useEffect, useState } from 'react'

import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import {
  Button,
  Col,
  Form,
  Input,
  PageHeader,
  Radio,
  Result,
  Row,
  Table,
} from 'antd'
import { SelectFieldAnt } from 'Components/Form'
import { SelectItemProps } from 'Components/Form/Select'
import ID_COMPONENTE from 'config/idComponente'
import { Roles } from 'Models/auth'
import { IAlertaTipo } from 'Models/docas'
import { useForm } from 'react-hook-form'
import AuthService from 'Services/UAA'
import WsDocasService from 'Services/WS_DOCAS'
import swal from 'sweetalert'

const ModalConfigurarAlertas = (): ReactElement => {
  const [alertasTipos, setAlertasTipos] = useState<IAlertaTipo[]>([])
  const [roles, setRoles] = useState<Roles[]>([])
  const [selectRoleItens, setSelectRoleItens] = useState<SelectItemProps[]>([])
  const [formulario] = Form.useForm<IAlertaTipo>()
  const hookForm = useForm()
  const [visualizarAlertas, setVisualizarAlertas] = useState<boolean>(true)
  const [carregandoInclusaoEdicao, setCarregandoInclusaoEdicao] =
    useState<boolean>(false)
  const [carregandoGrid, setCarregandoGrid] = useState<boolean>(false)
  const [edicaoAlerta, setEdicaoAlerta] = useState<boolean>(false)
  const [result, setResult] = useState<number>(0)
  const [mensagem, setMensagem] = useState<string>()

  const cadastraOuEditaAlerta = async (alerta: IAlertaTipo) => {
    try {
      setCarregandoInclusaoEdicao(true)

      if (alerta.ativo === undefined || alerta.ativo === null) {
        alerta.ativo = true
      }

      if (alerta.idsRoles) {
        for (let i = 0; i < alerta.idsRoles.length; i++) {
          if (isNaN(alerta.idsRoles[i])) {
            alerta.idsRoles[i] = roles.find(
              (f) => f.name == alerta.idsRoles[i],
            )!.id
          }
        }
      }

      const { data } = edicaoAlerta
        ? await WsDocasService.alerta.updateTipo(ID_COMPONENTE.DOCAS, alerta)
        : await WsDocasService.alerta.createTipo(ID_COMPONENTE.DOCAS, alerta)

      let mensagem: string

      if (data.statusCode == 501) {
        setResult(200)
        mensagem =
          'Alerta ' + (edicaoAlerta ? 'editado' : 'cadastrado') + ' com sucesso'
      } else {
        setResult(400)
        mensagem =
          'Ocorreu um problema' +
          (edicaoAlerta ? ' na edição' : 'no cadastro') +
          ' do alerta, favor contatar o suporte do Compulog'

        if (data.message) {
          mensagem += ': ' + data.message
        }
      }

      setMensagem(mensagem)
      setEdicaoAlerta(false)
      await getAlertasTipos()
      setCarregandoInclusaoEdicao(false)
      formulario.resetFields()
    } catch (e) {
      setResult(400)
      setMensagem(
        'Ocorreu um problema' +
          (edicaoAlerta ? ' na edição' : 'no cadastro') +
          ' do alerta, favor contatar o suporte do Compulog',
      )
    }
  }

  const preparaEdicao = (cdAlertaTipo: number) => {
    const alerta: IAlertaTipo | undefined = alertasTipos.find(
      (f) => f.cdAlertaTipo === cdAlertaTipo,
    )

    if (alerta) {
      const valoresFormulario = {
        cdAlertaTipo: alerta.cdAlertaTipo,
        nome: alerta.nome,
        descricao: alerta.descricao,
        ativo: alerta.ativo,
        tempo: alerta.tempo,
        idsRoles: roles
          .filter((f) => alerta.idsRoles.includes(f.id))
          .map((role) => role.name),
      }
      setVisualizarAlertas(false)
      setEdicaoAlerta(true)
      formulario.setFieldsValue(valoresFormulario)
    } else {
      alert(
        'Ocorreu um problema na edição do alerta, favor contatar o suporte do Compulog',
      )
    }
  }

  const removeAlerta = async (cdAlertaTipo: number) => {
    const { data } = await WsDocasService.alerta.deleteTipo(
      ID_COMPONENTE.DOCAS,
      cdAlertaTipo,
    )

    if (data.statusCode == 501) {
      setResult(200)
      setMensagem('Alerta removido com sucesso')
    } else {
      setResult(400)
      setMensagem(
        'Ocorreu um problema na remoção do alerta, favor contatar o suporte do Compulog',
      )
    }

    setVisualizarAlertas(false)
    await getAlertasTipos()
  }

  const preparaRemocao = (cdAlertaTipo: number) => {
    swal({
      title: 'Confirmar?',
      text:
        'Tem certeza que deseja remover o alerta ' +
        (alertasTipos.find((f) => f.cdAlertaTipo === cdAlertaTipo)?.nome ??
          'selecionado') +
        '?',
      icon: 'warning',
      buttons: ['NÃO', 'SIM'],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        removeAlerta(cdAlertaTipo)
      }
    })
  }

  const getRoles = async () => {
    const { data } = await AuthService.GetRoles()

    if (data) {
      const selectRoleData: SelectItemProps[] = data.map((item: Roles) => {
        return {
          value: item.id.toString(),
          label: item.name,
        }
      })

      setSelectRoleItens(selectRoleData)
      setRoles(data)
    }
  }

  const getAlertasTipos = async () => {
    setCarregandoGrid(true)

    const { data } = await WsDocasService.alerta.getListTipo(
      ID_COMPONENTE.DOCAS,
    )

    if (data.items) {
      setAlertasTipos(data.items)
    }

    setCarregandoGrid(false)
  }

  useEffect(() => {
    getRoles()
    getAlertasTipos()
  }, [])

  return (
    <>
      {visualizarAlertas ? (
        <Row>
          <Col span={24}>
            <Button onClick={() => setVisualizarAlertas(false)}>
              <PlusOutlined /> Cadastrar alerta
            </Button>
          </Col>
          <Col span={24}>
            <Table
              size="small"
              pagination={false}
              scroll={{ y: 440 }}
              loading={carregandoGrid}
              columns={[
                {
                  title: '',
                  key: 'cdAlertaTipo',
                  dataIndex: 'cdAlertaTipo',
                  width: '50px',
                  render: (cdAlertaTipo: number) => (
                    <>
                      <span
                        style={{ cursor: 'pointer' }}
                        title="Editar"
                        onClick={() => preparaEdicao(cdAlertaTipo)}
                      >
                        <EditOutlined />
                      </span>
                      <span
                        style={{ cursor: 'pointer', marginLeft: '6px' }}
                        title="Remover"
                        onClick={() => preparaRemocao(cdAlertaTipo)}
                      >
                        <DeleteOutlined />
                      </span>
                    </>
                  ),
                },
                {
                  title: 'Nome',
                  key: 'nome',
                  dataIndex: 'nome',
                },
                {
                  title: 'Tempo (em minutos)',
                  key: 'tempo',
                  dataIndex: 'tempo',
                },
                {
                  title: 'Situação',
                  key: 'ativo',
                  dataIndex: 'ativo',
                  render: (ativo: boolean) => (ativo ? 'Ativo' : 'Inativo'),
                },
              ]}
              dataSource={alertasTipos}
            />
          </Col>
        </Row>
      ) : result === 0 ? (
        <Form
          onFinish={cadastraOuEditaAlerta}
          layout="vertical"
          form={formulario}
        >
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="nome"
                label="Nome:"
                rules={[{ required: true, message: 'Campo obrigatório' }]}
              >
                <Input type="text" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item name="descricao" label="Descrição:">
                <Input type="text" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item name="ativo" label="Situação:">
                <Radio.Group defaultValue={true}>
                  <Radio value={true}>Ativo</Radio>
                  <Radio value={false}>Inativo</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="tempo"
                label="Tempo (em minutos):"
                rules={[{ required: true, message: 'Campo obrigatório' }]}
              >
                <Input type="number" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <SelectFieldAnt
                methods={hookForm}
                scope="form-configuracao-alertas"
                label="Grupos de usuários para notificar:"
                name="idsRoles"
                items={selectRoleItens}
                showSearch={true}
                mode="multiple"
              />
            </Col>

            <Col span={8} style={{ display: 'none' }}>
              <Form.Item name="cdAlertaTipo" label="Código">
                <Input type="number" readOnly={true} />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Button
                key="cadastraEditaAlerta"
                type="primary"
                htmlType="submit"
                loading={carregandoInclusaoEdicao}
              >
                {edicaoAlerta ? 'Salvar' : 'Cadastrar'}
              </Button>
              <Button
                key="voltar"
                type="primary"
                onClick={() => {
                  setVisualizarAlertas(true)
                  formulario.resetFields()
                }}
                style={{ marginLeft: '-12px' }}
              >
                Voltar
              </Button>
            </Col>
          </Row>
        </Form>
      ) : (
        <Result
          status={result === 200 ? 'success' : 'error'}
          title={mensagem}
          extra={[
            <Button
              type="primary"
              key="console"
              onClick={() => {
                setResult(0)

                if (result === 200) {
                  setVisualizarAlertas(true)
                }
              }}
            >
              Voltar
            </Button>,
          ]}
        />
      )}
    </>
  )
}

export default ModalConfigurarAlertas
